module.exports = __webpack_public_path__ + "img/zhicunbao_2.157c66ca.png";